"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.animation = exports.reservedKeys = void 0;

var _Calendar = _interopRequireDefault(require("@p24/icons/Calendar"));

var reservedKeys = ['display', 'appearance', 'zIndex', 'width', 'minWidth', 'calendarAnimation'];
exports.reservedKeys = reservedKeys;
var animation = {
  from: {
    opacity: 0.5,
    transform: 'scaleY(0)'
  },
  enter: {
    opacity: 1,
    transform: 'scaleY(1)'
  },
  leave: {
    opacity: 0,
    transform: 'scaleY(0)'
  },
  "native": true,
  config: {
    duration: 150
  }
};
exports.animation = animation;

function _default(palette) {
  return {
    palette: palette,
    display: 'inline-block',
    appearance: _Calendar["default"],
    zIndex: palette.zOverlay,
    width: 'auto',
    minWidth: 'auto',
    calendarAnimation: animation
  };
}